<template>
    <div class="printOrderDetails">
        <!-- 订单状态 -->
        <div class="detailsState">
            <div class="detailsState_one">
                <i
                    class="el-icon-arrow-left"
                    @click="$router.go(-1)"
                ></i>
                <p class="detailsState_one_title">订单状态</p>
                <span v-if="processStatus==='UN_SEND'">买家已付款，待发货</span>
                <span v-if="processStatus==='UN_RECEIVE'">卖家已发货</span>
                <span v-if="processStatus==='UN_APPRAISE'">买家确认收货</span>
                <span v-if="processStatus==='FINISHED'">交易已成功</span>
            </div>
        </div>
        <!-- 报价流程 -->
        <div class="details">
            <div class="detailsProcess">
                <div class="processItem" v-for="(item,index) in processList" :key="index">
                    <div :class="processStatus === item.id?'process_type process_type2':'process_type'">
                        <i>{{index + 1}}</i>
                        <p>{{item.name}}</p>
                    </div>
                    <i class="el-icon-arrow-right typeIcon" v-show="item.id !== 'FINISHED'"></i>
                </div>
            </div>
            <!--收货/发票信息-->
            <div class="basicInformation">
                <div class="goodsReceiving">
                    <h3>收货信息</h3>
                    <div class="goodsItem">
                        <div class="name">收货地址：</div>
                        <div class="content">{{ payeeDetail.province }}{{ payeeDetail.city }}{{ payeeDetail.district }}{{ payeeDetail.areaInfo }}</div>
                    </div>
                    <div class="goodsItem">
                        <div class="name">收货人：</div>
                        <div class="content">{{ payeeDetail.receiverName }}</div>
                    </div>
                    <div class="goodsItem">
                        <div class="name">手机号码：</div>
                        <div class="content">{{ payeeDetail.mobile }}</div>
                    </div>
                </div>
            </div>
            <!--物流信息-->
            <div class="logisticsInformation">
                <h3>物流信息</h3>
                <div class="logisticsContent">
                    <div class="logisticsLeft">
                        <div class="orderItem" v-show="logisticsTrackVisible">
                            <div class="content">暂无物流信息</div>
                        </div>
                        <el-timeline v-show="!logisticsTrackVisible&&logisticsList.length>0">
                            <el-timeline-item :class="index === 0?'timelineItemActive':''" :timestamp="item.ftime" :color="index === 0?'#1890FF':'#B2B2B2'" placement="top" v-for="(item,index) in logisticsList" :key="index">
                                <div class="timelineItemClass">
                                    <el-button class="newest" v-if="index === 0">最新</el-button>
                                    <div class="content">{{item.context}}</div>
                                </div>
                            </el-timeline-item>
                        </el-timeline>
                        <div class="orderItem" v-show="!logisticsTrackVisible&&logisticsList.length==0">
                            <div class="content">{{ logisitcsResult }}({{ orderBase.logisticsUuid }}-{{ orderBase.logisticsNo }})</div>
                        </div>
                    </div>
                    <div class="logisticsRight"></div>
                </div>
            </div>
            <!--订单信息-->
            <div class="orderInformation">
                <div class="orderTop">
                    <h3>订单信息</h3>
                    <div class="orderItem">
                        <div class="name">服务商：</div>
                        <div class="content">{{ orderShopInfo.storeName }} </div>
                    </div>
                </div>
                <div class="orderBottom">
                    <div class="orderItem">
                        <div class="name">订单编号：</div>
                        <div class="content">{{ orderBase.orderNo }}</div>
                    </div>
                    <div class="orderItem">
                        <div class="name">创建时间：</div>
                        <div class="content">{{ orderBase.createDate }}</div>
                    </div>
                    <div class="orderItem" v-if="orderBase.payType">
                        <div class="name">付款时间：</div>
                        <div class="content">{{ orderBase.payDate }}</div>
                    </div>
                </div>
            </div>
            <!--打印信息-->
            <div class="printInformation">
                <h3>商品信息</h3>
                <div class="printTableContent">
                    <div class="tableHeader">
                        <div class="sort">序号</div>
                        <div class="name">商品信息</div>
                        <div class="activeName">活动名称</div>
                        <div class="price">兑换积分数</div>
                        <div class="num">数量</div>
                    </div>
                    <div class="tableBody">
                        <div class="sort">
                            <div v-for="(item,index) in shopList" :key="index">{{ index+1>9?index+1:"0"+(index+1) }}</div>
                        </div>
                        <div class="name">
                            <div class="orderInfo" v-for="(item,index) in shopList" :key="index">
                                <img :src="item.specUrl" alt="">
                                <div class="infoContent">
                                    <div class="infoName">{{ item.goodsName }}-{{ item.specName }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="activeName">
                            <div>
                                {{ orderBase.activityName }}
                            </div>
                        </div>
                        <div class="price">
                            <div v-for="(item,index) in shopList" :key="index">
                                {{ item.price }}
                            </div>
                        </div>
                        <div class="num">
                            <div v-for="(item,index) in shopList" :key="index">
                                {{ item.num }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--商品价格-->
            <div class="commodityPrices">
                <div class="priceItem">
                    <div class="name">小计：</div>
                    <div class="content"> {{ orderBase.updateTotalPrice }}</div>
                </div>
                <div class="priceItem">
                    <div class="name">运费：</div>
                    <div class="content">¥ 0</div>
                </div>
                <div class="priceItem fontWeight">
                    <div class="name">总积分：</div>
                    <div class="content"> {{ orderBase.totalPrice }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getOrderShopInfo, getAddressDetail,getDictionaryItem, getLogisticsTrack  } from '../../../utils/interface';
export default {
    name: "mallOrderDetails",
    data() {
        return {
            processStatus: '',
            processList: [
                {
                    id: "UN_SEND",
                    name: "待发货",
                },
                {
                    id: "UN_RECEIVE",
                    name: "待收货",
                },
                {
                    id: "UN_APPRAISE",
                    name: "待评价",
                },
                {
                    id: "FINISHED",
                    name: "完成",
                },
            ],
            day: 0,
            hr: 0,
            min: 0,
            sec: 0,
            logisticsList: [],
            logisticsUuid: '',
            logisticsNo: '',
            logisticsCompany:'',
            logisticsTrackVisible: true,
            logisitcsResult:'',
            payeeInfo:"",
            payeeDetail:"",
            invoiceInfo:"",
            type: '',
            issueInvoice:{},
            orderBaseUuid:"",
            orderShopInfo:{},
            orderBase:{},
            shopList:[],
            logisticsCompanyList:[],
        }
    },
    created(){
        this.orderBaseUuid = this.$route.query.orderBaseUuid;
        this.getOrderShopInfo();
        this.getLogisticsCompanyList()
    },
    mounted() {
        this.countdown()
    },
    methods: {
        getLogisticsCompanyList(val){
            getDictionaryItem({groupCode:'delivery_type'}).then(res=>{
                this.logisticsCompanyList=res;
            });
        },
        getOrderShopInfo(){
            let params = {
                orderBaseUuid:this.orderBaseUuid
            };
            getOrderShopInfo(params).then((res)=>{
                if(res) {
                    this.orderShopInfo = res;
                    this.orderBase = res.orderBase;
                    this.processStatus = res.orderBase.orderStatus;
                    this.shopList = res.shopList;
                    //物流信息
                    if(this.orderBase.logisticsNo!=null&&this.orderBase.logisticsUuid!=null) {
                        //this.viewLogisticsInfo(this.orderBase.uuid);
                        this.viewLogisticsInfo(this.orderBase.uuid);
                    }
                    // 查询收货地址
                    if(this.shopList.length>0){
                        getAddressDetail({uuid:this.shopList[0].sendPostUuid}).then((res)=>{
                            this.payeeDetail = res;
                        });
                    }
                }
            });
        },
        // 倒计时
        countdown(date) {
            // 定义结束时间戳
            let end = new Date(date);
            // 定义当前时间戳
            let now = new Date();
            // 做判断当倒计时结束时都为0
            if (now >= end) {
                this.day = 0;
                this.hr = 0;
                this.min = 0;
                this.sec = 0;
                return
            }
            // 用结束时间减去当前时间获得倒计时时间戳
            let msec = end - now;
            //算出天数
            let day = parseInt(msec / 1000 / 60 / 60 / 24);
            //算出小时数
            let hr = parseInt(msec / 1000 / 60 / 60 % 24);
            //算出分钟数
            let min = parseInt(msec / 1000 / 60 % 60);
            //算出秒数
            let sec = parseInt(msec / 1000 % 60);
            //给数据赋值
            this.day = day;
            this.hr = hr > 9 ? hr : '0' + hr;
            this.min = min > 9 ? min : '0' + min;
            this.sec = sec > 9 ? sec : '0' + sec;
            setTimeout(()=> {
                this.countdown(date);
            }, 1000)
        },
        startChat() {},
        // 查看实时物流
        getLogisticsCompanyList(){
            getDictionaryItem({groupCode:'delivery_type'}).then(res=>{
                this.logisticsCompanyList=res;
            });
        },
        // 查看实时物流
        viewLogisticsInfo(uuid,logisticsNo,logisticsUuid){

            this.logisticsList=[]
            this.logisticsUuid=''
            this.logisticsNo= ''
            this.logisticsCompany=''

            let params = {
                uuid:uuid,
                logisticsNo:logisticsNo,
                logisticsUuid:logisticsUuid
            };
            getLogisticsTrack(params).then((res)=>{
                if(res.success){
                    if(res.data.status === '200'){
                        //接口查询成功
                        this.logisticsTrackVisible = false;
                        this.logisticsNo = res.data.nu;
                        this.logisticsCompany = this.logisticsCompanyList.find(i => i.code === res.data.com)
                        this.logisticsList = res.data.data
                    }else{
                        this.logisticsTrackVisible = false;
                        this.logisitcsResult = res.data.message;
                        this.$message({
                            type: 'warning',
                            message: res.data.message
                        });
                    }
                }else{
                    this.logisticsTrackVisible = true;
                }
            });
        },
    },
}
</script>

<style scoped lang="less">
p {
    margin: 0;
}
i {
    font-style: normal;
}
.printOrderDetails {
    background: #f5f5f5;
    margin-left: 20px;
    // 订单状态
    .detailsState {
        background: #fff;
        font-size: 14px;
        padding: 26px 32px;
        margin-bottom: 8px;
        .detailsState_one {
            display: flex;
            align-items: center;
            position: relative;
            &:nth-of-type(1) {
                margin-bottom: 16px;
            }
            i {
                font-size: 18px;
                margin-right: 5px;
                cursor: pointer;
                position: absolute;
                left: -24px;
            }
            span{
                color: rgba(0,0,0,.5);
            }
            .detailsState_one_title {
                font-size: 16px;
                font-weight: 700;
                margin-right: 8px;
            }
            .detailsState_one_time {
                color: #1890ff;
            }
        }
    }
    // 报价流程
    .details {
        background: #fff;
        padding: 0 8px 150px;
        .detailsProcess {
            border-bottom: 1px solid #efefef;
            display: flex;
            align-items: center;
            .processItem{
                display: flex;
                align-items: center;
                /*  cursor: pointer;
                  &:hover{
                      .process_type{
                          i {
                              background: #1890ff;
                              color: #fff;
                              border: 1px solid #1890ff;
                          }
                          p {
                              color: #000;
                          }
                      }
                  }*/
            }
            .process_type {
                width: 190px;
                height: 64px;
                // line-height: 64px;
                display: flex;
                align-items: center;
                // border-bottom: 2px solid #1890ff;
                text-align: center;
                justify-content: center;
                i {
                    display: inline-block;
                    width: 24px;
                    height: 24px;
                    border: 1px solid rgba(0, 0, 0, 0.15);
                    border-radius: 50%;
                    color: rgba(0, 0, 0, 0.15);
                    line-height: 27px;
                    font-size: 14px;
                    margin-right: 8px;
                }
                p {
                    font-size: 16px;
                    color: rgba(0, 0, 0, 0.3);
                }
            }
            .typeIcon {
                color: rgba(0, 0, 0, 0.3);
                font-size: 18px;
            }
            .process_type2 {
                border-bottom: 3px solid #1890ff;
                i {
                    background: #1890ff;
                    color: #fff;
                    border: 1px solid #1890ff;
                }
                p {
                    color: #000;
                }
            }
        }

        //发票信息样式
        .invoiceCenter{
            padding: 25px 32px;
            border-bottom: 1px solid #ddd;
            h3{
                color: rgba(0, 0, 0, 0.85);
                font-size: 16px;
            }
            .goodsItem{
                display: flex;
                font-size: 14px;
                padding-bottom: 14px;
                .name{
                    color: rgba(0, 0, 0, 0.85);
                }
                .content{
                    color: rgba(0, 0, 0, 0.65);
                }
            }
        }
        .basicInformation{
            display: flex;
            padding: 25px 32px;
            border-bottom: 1px solid #ddd;
            h3{
                margin: 0;
                font-size: 16px;
                font-weight: 700;
                color: rgba(0, 0, 0, 0.85);
                line-height: 24px;
                padding-bottom: 20px;
            }
            .goodsItem{
                display: flex;
                padding-bottom: 14px;
                font-size: 14px;
                .name{
                    color: rgba(0, 0, 0, 0.85);
                    min-width: 80px;
                }
                .content{
                    color: rgba(0, 0, 0, 0.65);
                }
            }
            .goodsReceiving{
                width: 50%;
                padding-right: 32px;
                // border-right: 1px solid #ddd;
            }
            .invoiceInformation{
                width: 50%;
                padding-left:32px;
            }
        }
        .logisticsInformation{
            padding: 25px 32px;
            // padding-left: 32px;
            border-bottom: 1px solid #ddd;
            h3{
                margin: 0;
                font-size: 16px;
                font-weight: 700;
                color: rgba(0, 0, 0, 0.85);
                line-height: 24px;
                padding-bottom: 20px;
            }
            .logisticsContent{
                display: flex;
                .logisticsLeft{
                    /deep/.el-timeline-item__wrapper{
                        padding-left: 80px;
                    }
                    .timelineItemActive{
                        /deep/.el-timeline-item__timestamp{
                            color: #1890FF;
                        }
                        .content{
                            color: #1890FF;
                        }
                        .timelineItemClass{
                            position: relative;
                            button{
                                position: absolute;
                                left: -58px;
                                top: -21px;
                                width: 44px;
                                height: 24px;
                                background: #1890FF;
                                border-radius: 2px;
                                padding: 0;
                                text-align: center;
                                line-height: 24px;
                                color: #fff;
                                font-size: 12px;
                                border: none;
                                cursor: default;
                            }
                        }
                    }
                    .timelineItemClass{
                        font-size: 14px;
                    }
                    /deep/.el-timeline-item{
                        padding-bottom:30px;
                    }
                }
            }
        }
        .orderInformation{
            padding: 25px 32px;
            border-bottom: 1px solid #ddd;
            h3{
                margin: 0;
                font-size: 16px;
                font-weight: 700;
                color: rgba(0, 0, 0, 0.85);
                line-height: 24px;
                padding-bottom: 20px;
            }
            .orderTop{
                display: flex;
                .orderItem{
                    padding-left: 50px;
                    i{
                        color: #1890FF;
                        padding-left: 10px;
                        cursor: pointer;
                    }
                }
            }
            .orderBottom{
                display: flex;
                .orderItem{
                    display: flex;
                    align-items: center;
                    margin-right: 20px;
                }
            }
            .orderItem{
                font-size: 14px;
                display: flex;
                // width: 20%;
                .name{
                    color: rgba(0, 0, 0, 0.85);
                }
                .content{
                    color: rgba(0, 0, 0, 0.65);
                }
            }
        }
        .printInformation{
            padding: 25px 32px;
            border-bottom: 2px dashed #000;
            h3{
                margin: 0;
                font-size: 16px;
                font-weight: 700;
                color: rgba(0, 0, 0, 0.85);
                line-height: 24px;
                padding-bottom: 20px;
            }
            .printTableContent{
                .tableHeader{
                    display: flex;
                    height: 54px;
                    background:rgba(0,0,0,.02);
                    line-height: 54px;
                    font-size: 14px;
                    color: #000000;
                }
                .tableBody{
                    display: flex;
                    align-items: center;
                    .name{
                        text-align: left;
                    }
                    .explain {
                        padding: 20px;
                    }
                    .sort,.price,.num{
                        div{
                            line-height: 204px;
                        }
                    }
                    .price{
                        color: #E42424;
                    }
                    .argumentsName {
                        padding-bottom: 8px;
                        font-size: 14px;
                        span{
                            color: rgba(51, 51, 51, 0.85);
                        }
                    }
                }
                .orderInfo {
                    padding: 50px 20px;
                    display: flex;
                    justify-content: center;
                    img {
                        display: block;
                        width: 100px;
                        height: 100px;
                        border-radius: 10px;
                        margin-right: 30px;
                    }

                    .infoContent {
                        .infoName {
                            font-size: 14px;
                            color: #000000;
                            padding-bottom: 10px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            max-width: 550px;
                        }

                        .infoOther {
                            font-size: 13px;
                            color: #999999;
                            padding-bottom: 8px;
                        }
                    }
                }
                .sort{
                    width: 60px;
                    text-align: center;
                    padding: 0 10px;
                }
                .name{
                    flex: 1;
                    text-align: center;
                    padding: 0 10px;
                    min-width: 600px;
                }
                .explain{
                    text-align: center;
                    padding: 0 10px;
                    width: 400px;
                }
                .price{
                    text-align: center;
                    padding: 0 10px;
                    width: 150px;
                }
                .num{
                    text-align: center;
                    padding: 0 10px;
                    width: 150px;
                }
            }
        }
        .commodityPrices{
            padding: 20px 30px 0 0;
            .priceItem{
                display: flex;
                justify-content: flex-end;
                padding-bottom: 15px;
                font-size: 14px;
                color: #404040;
                .content{
                    min-width: 100px;
                    text-align: right;
                }
                &.fontWeight{
                    font-weight: 700;
                    .content{
                        color: #FF375F;
                    }
                }
            }
        }
        .functionButton{
            position: fixed;
            bottom: 20px;
            right: 30px;
        }
    }
}
.billingInformation{
    .title{
        color: rgba(0, 0, 0, 0.85);
        padding: 5px 0 10px 15px;
        border-bottom: 1px solid #ddd;
        font-weight: 700;
    }
    .billingContent{
        padding: 10px 10px 0;
        color: rgba(0, 0, 0, 0.65);
        .billingItem{
            display: flex;
            padding-bottom: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/integral/integralDialog/integralOrderDetails.vue